import getUserLocale from 'get-user-locale';
export var formatHour = function formatHour(locale, hour) {
  return hour.toLocaleString(locale || getUserLocale());
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-clock/dist/esm/shared/hourFormatter.js
// module id = null
// module chunks = 